import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ToggleConfirmationDialog = class ToggleConfirmationDialog extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.confirmation = '';
        this.confirmErrors = [];
    }
    /**
     * event handler if component is confirmed
     */
    get setHeight() {
        console.log(this.message.length);
        return {
            height: `${this.height}px`,
        };
    }
    get setMobileHeight() {
        // trial and error height for mobile
        // const mobile_height = this.message.length * 0.35 + this.header.length * 0.69 + 280;
        // return {
        //   height: `${mobile_height}px`,
        // };
        const mobile_height = parseInt(this.height, 10) + 50;
        return {
            height: `${mobile_height}px`,
        };
    }
    confirmed() {
        if (this.confirmation === 'CONFIRM') {
            this.$emit('confirm');
            this.confirmation = '';
            this.confirmErrors = [];
        }
        else {
            this.confirmErrors = ["Please type 'CONFIRM' in all caps to confirm"];
        }
    }
    onCancel() {
        this.confirmation = '';
        this.$emit('cancel');
        this.confirmErrors = [];
    }
};
__decorate([
    Getter('toggleConfirmation')
], ToggleConfirmationDialog.prototype, "toggleConfirmation", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ToggleConfirmationDialog.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "note", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: 'Confirmation' })
], ToggleConfirmationDialog.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: "To Confirm this change, kindly type in 'CONFIRM' in the field" })
], ToggleConfirmationDialog.prototype, "message", void 0);
__decorate([
    Prop({ type: String, default: 'OK' })
], ToggleConfirmationDialog.prototype, "confirmLabel", void 0);
__decorate([
    Prop({ type: String, default: '400' })
], ToggleConfirmationDialog.prototype, "width", void 0);
__decorate([
    Prop({ type: String, default: '315' })
], ToggleConfirmationDialog.prototype, "height", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "remove", void 0);
ToggleConfirmationDialog = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
        },
    })
], ToggleConfirmationDialog);
export default ToggleConfirmationDialog;
